<template>
    <div
        id="main-container"
        class="is-justify-content-center has-background-greyBG"
    >
        <main class="box-center-vertical is-justify-content-center">
            <div class="columns is-centered mt-6">
                <div class="column is-12">
                    <div class="columns box is-block is-radiusless">
                        <div class="column is-12 is-inline-flex">
                            <h6
                                class="is-subtitle is-primary has-text-weight-medium is-pull-left"
                            >
                                {{ $t("call-room.title") }}
                            </h6>
                            <img
                                class="iconRegistro ml-4"
                                src="@/assets/icons/callRegister.svg"
                                width="30"
                                height="25"
                            />
                        </div>
                        <div class="column is-12 is-inline-flex" v-if="isLoading"> 
                            <Loading />
                        </div>
                        <div class="column is-12 is-inline-flex" v-else>
                            <table class="table is-striped is-hoverable is-fullwidth">
                                <thead>
                                    <tr>
                                        <th>Conectado</th>
                                        <th>Título</th>
                                        <th>Sala</th>
                                        <th>En línea</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(row, idx) in items">
                                        <tr :key="idx" @click="createRoom(row)" class="is-pointer">
                                            <td>{{ formatDate(row.connected) }}</td>
                                            <td>{{ row.title }}</td>
                                            <td>{{ row.roomId ? row.roomId : 'Esperando...' }}</td>
                                            <td>{{ row.online ? 'ON' : 'OFF' }}</td>
                                        </tr>
                                    </template>
                                    <tr v-if="totalPages === 0">
                                        <td align="center" colspan="3">No hay solicitudes...</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="column is-12 is-inline-flex">
                            <nav class="pagination" role="navigation" aria-label="pagination" v-if="totalPages > 1">
                                <a class="pagination-previous" v-if="currentPage > 1" v-on:click="prev()">Anterior</a>
                                <a class="pagination-previous" v-if="currentPage < totalPages" v-on:click="next()">Siguiente</a>

                                <ul class="pagination-list">
                                    <li v-if="currentPage > 2">
                                        <a class="pagination-link" @click="goto(1)" aria-label="Goto page 1">1</a>
                                    </li>

                                    <li v-if="currentPage > 3">
                                        <span class="pagination-ellipsis">&hellip;</span>
                                    </li>
                                    <li v-if="currentPage > 1">
                                        <a
                                            class="pagination-link"
                                            v-on:click="goto(currentPage - 1)"
                                            :aria-label="'Goto page ' + (this.currentPage - 1)"
                                        >{{currentPage - 1}}</a>
                                    </li>
                                    <li>
                                        <a
                                            class="pagination-link is-current"
                                            v-on:click="goto(currentPage)"
                                            :aria-label="'Goto page ' + this.currentPage"
                                            aria-current="page"
                                        >{{currentPage}}</a>
                                    </li>
                                    <li v-if="totalPages > currentPage">
                                        <a
                                            class="pagination-link"
                                            v-on:click="goto(currentPage + 1)"
                                            :aria-label="'Goto page ' + (this.currentPage + 1)"
                                        >{{currentPage + 1}}</a>
                                    </li>
                                    <li v-if="totalPages - currentPage > 2">
                                        <span class="pagination-ellipsis">&hellip;</span>
                                    </li>

                                    <li v-if="totalPages - currentPage > 1">
                                        <a
                                            class="pagination-link"
                                            v-on:click="goto(totalPages)"
                                            :aria-label="'Goto page ' + this.totalPages"
                                        >{{this.totalPages}}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import moment from "moment";
import { RepositoryFactory } from "@/services/api";
import Loading from "@/components/Loading";
import { mapGetters } from "vuex";

export default {
    name: "survey-online-rooms-list",
    components: {
        Loading,
    },
    props: {
        signalRSocket: { type: Object, required: true },
    },
    computed: {        
        ...mapGetters("oidcStore", ["oidcIsAuthenticated", "oidcUser"]),
        operatorId() {
            return this.oidcUser?.sub;
        },
        roles() {
            return this.oidcUser?.role;
        }
    },
    data() {
        return {
            isLoading: false,
            items: [],
            currentPage: 1,
            totalPages: 0,
            loadingContent: false,
            filters: {
                page: 1,
                take: 10,
                search: ""
            }
        };
    },
    mounted() {
        if (this.signalRSocket) {
            this.signalRSocket.on("ReceiveSurveyOnlineUser", this.signalRReceiveSurveyOnlineUser);
            this.signalRSocket.on("StatusSurveyOnlineRoom", this.signalRStatusSurveyOnlineRoom);
        }

        this.getItems();
    },
    methods: {
        async signalRReceiveSurveyOnlineUser(surveyOnlineUserId) {
            window.console.log(surveyOnlineUserId);
            this.getItems();
        },
        async signalRStatusSurveyOnlineRoom(surveyRoomOnline) {
            window.console.log(surveyRoomOnline);
            if (surveyRoomOnline && surveyRoomOnline.status == "Attending" && surveyRoomOnline.operatorId == this.operatorId) {
                this.$router.push({
                    name: "room",
                    params: { roomId: surveyRoomOnline.roomId },
                });

                return;
            }
            
            this.getItems();
        },
        async getItems() {
            try {
                var response = await RepositoryFactory.conference.getPagedSurveyOnlineUsers(this.filters);
                this.items = response.data.items;
                this.totalPages = response.data.pages;
            } catch (error) {
                window.console.log(error);
            }
        },
        async createRoom(item) {
            this.isLoading = true;
            let surveyId = item.surveyId;
            let roomId = null;

            if (item.roomId) {
                roomId = item.roomId;
            }
            else
            {
                try {
                    let response = await RepositoryFactory.conference.create({
                        name: item.title,
                        description: item.environment,
                    });
                    roomId = response.data;
                    await RepositoryFactory.conference.setSurveyOnlineUser({
                        surveyId : item.surveyId,
                        environment : item.environment,
                        roomId: roomId
                    });
                } catch (error) {
                    window.console.log(error);
                }
            }

            if (this.operatorId && this.signalRSocket && roomId) {
                await this.signalRSocket.invoke(
                    "SurveyOnlineRoom",
                    surveyId,
                    roomId,
                    this.operatorId
                ).catch(err => console.log(err));
            }
            
            if (this.signalRSocket) {
                await this.signalRSocket.invoke(
                    "DestroySurveyOnlineUser",
                    item.id
                ).catch(err => console.log(err));
            }
            
            this.isLoading = false;
        },
        goto(page) {
            this.currentPage = page;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        prev() {
            this.currentPage = this.currentPage - 1;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        next() {
            this.currentPage = this.currentPage + 1;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY hh:mm A");
        }
    },
};
</script>
